export enum TaskTransferTypes {
    Doctor = 1,
    Administrator = 2,
    Date = 3,
}
